import MatomoMessage from '@/matomo/message/MatomoMessage';
import MatomoNotificationMessage from '@/matomo/message/MatomoNotificationMessage';
import { MatomoActions } from '@/matomo/MatomoActions';

class TrackingEvents {
  public static trackingEvent = new MatomoMessage([MatomoActions.event]);
}

export class MatomoCartEvents {
  private static cartEvent = TrackingEvents.trackingEvent.with('Cart');

  public static addItemToCart = MatomoCartEvents.cartEvent.with('Add item to cart');
  public static addAllItemsToCart = MatomoCartEvents.cartEvent.with('Add all Items to Cart');
  public static removeItemFromCart = MatomoCartEvents.cartEvent.with('Remove Item from Cart');
  public static removeAllItemsFromCart = MatomoCartEvents.cartEvent.with('Remove all items from Cart');
  public static restoreToCart = MatomoCartEvents.addItemToCart.with('Cart Restore');
}

export class MatomoBestFriendEvents {
  private static bestFriendEvent = TrackingEvents.trackingEvent.with('Best Friend');

  public static bestFriendDeleteOpenOrder = MatomoBestFriendEvents.bestFriendEvent.with('Delete Open Order');
}

export class MatomoProductEvents {
  private static productEvent = TrackingEvents.trackingEvent.with('Product');

  public static productChangeAmount = MatomoProductEvents.productEvent.with('Change Amount');
  public static productUnitChange = MatomoProductEvents.productEvent.with('Change Unit');
  public static downloadDatasheet = MatomoProductEvents.productEvent
    .with('Download Datasheet')
    .with('Download Datasheet');
}

export class MatomoLanguageEvents {
  public static changeLanguage = TrackingEvents.trackingEvent
    .with('Language')
    .with('Change Language')
    .with('Change Language');
}

export class MatomoNotificationEvents {
  public static readNotifications = MatomoNotificationMessage.from(
    TrackingEvents.trackingEvent.with('Notifications').with('Read Notifications').with('Read Notifications')
  );
}

export class MatomoInventoryEvents {
  public static deleteInventory = TrackingEvents.trackingEvent
    .with('Inventory')
    .with('Delete Inventory')
    .with('Delete Inventory');
}

export class MatomoOrderEvents {
  private static orderEvent = TrackingEvents.trackingEvent.with('Order');

  private static orderConfirmationDownload = MatomoOrderEvents.orderEvent.with('Download Order Confirmation');
  public static cartOrderConfirmationDownload = MatomoOrderEvents.orderConfirmationDownload.with('Cart - Confirmation');
}

export class MatomoLabelEvents {
  private static labelList = TrackingEvents.trackingEvent.with('Labels');

  public static addItemLabelList = MatomoLabelEvents.labelList.with('Add Label');
  public static removeItemLabelList = MatomoLabelEvents.labelList.with('Remove Label');
  public static removeAllLabelList = MatomoLabelEvents.labelList.with('Remove all Items from Label List');
  public static addAllItemsToLabelList = MatomoLabelEvents.labelList.with('Add all Items to Label List');
  public static generateLabelList = MatomoLabelEvents.labelList.with('Generate Label List').with('Generate Label List');
  public static changeItemAmount = MatomoLabelEvents.labelList.with('Change Amount');
}

export class MatomoOrderTemplateEvents {
  private static orderTemplate = TrackingEvents.trackingEvent.with('Order Template');
  private static changeOrderTemplate = MatomoOrderTemplateEvents.orderTemplate.with('Change Order Template');

  public static downloadOrderTemplatePdf = MatomoOrderTemplateEvents.orderTemplate
    .with('Download Order Template')
    .with('Download Order Template');
  public static orderTemplateChangeOrderTemplate = MatomoOrderTemplateEvents.changeOrderTemplate.with('Order Template');
  public static addTemplate = MatomoOrderTemplateEvents.orderTemplate.with('Add Order Template');
  public static removeTemplate = MatomoOrderTemplateEvents.orderTemplate.with('Remove Order Template');
  public static addProduct = MatomoOrderTemplateEvents.orderTemplate.with('Add Product to Order Template');
  public static removeProduct = MatomoOrderTemplateEvents.orderTemplate.with('Remove Product from Order Template');
  public static changeProduct = MatomoOrderTemplateEvents.orderTemplate.with('Change Product of Order Template');
}

export class MatomoProductImageEvents {
  private static productImage = TrackingEvents.trackingEvent.with('Product Image');

  public static showOtherImage = MatomoProductImageEvents.productImage
    .with('Show other Image')
    .with('Show other Image');
  public static imageInteraction = MatomoProductImageEvents.productImage
    .with('Interact with 3D Image')
    .with('Interact with 3D Image');
}

export class MatomoEssenceEvents {
  private static dropdown = TrackingEvents.trackingEvent.with('Dropdown');

  public static toggleDropdown = MatomoEssenceEvents.dropdown.with('Open Dropdown');
}
